import styled, { css } from 'styled-components';
import { font } from '../../const/font';
import { marginStyle } from '../../const/helpers';
import { IconStyled } from '../icon';
import { ButtonProps } from './types';
import { buttonSize as s, buttonVariant as v } from './const';

export const ButtonStyled = styled.button<ButtonProps>`
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${({ $fontWeight }) => font.weight[$fontWeight]};
  min-height: ${({ $size }) => s[$size].height}px;
  font-size: ${({ $size }) => s[$size].fontSize}px;
  line-height: ${({ $size }) => s[$size].lineHeight}px;
  border-radius: ${({ $size, $rounded }) => ($rounded ? s[$size].height / 2 : s[$size].radius)}px;
  padding: ${({ $size, $variant }) => ($variant != 'link' ? `${s[$size].padding.map(e => `${e}px`).join(' ')}` : '0')};
  background-color: ${({ $variant, $color }) => v[$variant][$color].bg};
  color: ${({ $variant, $color }) => v[$variant][$color].color};
  border: ${({ $variant, $color }) => (v[$variant].border ? `1px solid ${v[$variant][$color].borderColor}` : 'none')};
  ${({ $m }) =>
    $m &&
    css`
      margin: ${$m.map(m => marginStyle(m)).join(' ')} !important;
    `}
  ${IconStyled} * {
    fill: ${({ $variant, $color }) => v[$variant][$color].color};
  }

  ${({ $defaultColor }) => `
    ${$defaultColor?.color && `color: ${$defaultColor.color};`}
    ${$defaultColor?.bg && `background-color: ${$defaultColor.bg};`}
  `};
  &:hover {
    background-color: ${({ $variant, $color }) => v[$variant][$color].hover.bg};
    color: ${({ $variant, $color }) => v[$variant][$color].hover.color};
    border: ${({ $variant, $color }) =>
      v[$variant].border ? `1px solid ${v[$variant][$color].hover.borderColor}` : 'none'};
    * {
      fill: ${({ $variant, $color }) => v[$variant][$color].hover.color};
    }

    text-decoration: ${({ $hoverTextDecoration }) => ($hoverTextDecoration ? $hoverTextDecoration : 'none')};

    ${({ $defaultColor }) => `
      ${$defaultColor?.colorHover && `color: ${$defaultColor.colorHover};`}
      ${$defaultColor?.bgHover && `background-color: ${$defaultColor.bgHover};`}
    `}
  }
  &:disabled {
    cursor: default;
    background-color: ${({ $variant, $color }) => v[$variant][$color].disabled.bg};
    color: ${({ $variant, $color }) => v[$variant][$color].disabled.color};
    border: ${({ $variant, $color }) =>
      v[$variant].border ? `1px solid ${v[$variant][$color].disabled.borderColor}` : 'none'};
    * {
      fill: ${({ $variant, $color }) => v[$variant][$color].disabled.color};
    }
  }
`;

export default ButtonStyled;
